import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3v6h2V5h4V3H3zm2 12H3v6h6v-2H5v-4zm14 4h-4v2h6v-6h-2v4zm2-16h-6v2h4v4h2V3z"
}), 'CropFreeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropFreeSharp.js
// module id = 3012
// module chunks = 2